import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const NoFilterStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 100%;
  gap: 1.6rem;

  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const IconContainer = styled.span`
  font-size: 9.2rem;
  line-height: 62.5%;
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  color: ${({ theme }) => theme.palette.text.secondary};
`;
